export default '/build/a325d5af.svg'